<template lang="pug">
v-dialog(
  max-width="500px",
  v-model="mode.userDialog",
  persistent,
  scrollable,
  transition="dialog-left-transition"
)
  v-card
    v-card-title.headline.grey.lighten-2.pa-1(primary-title)
      | {{  formTitle(&apos;User&apos;)  }}
      v-btn.pl-5(
        icon,
        v-if="editedItem.id && editedItem.status === STATUSES.INACTIVE",
        :disabled="isDirty",
        text,
        v-on:click.stop="deleteItem(dialogKey)"
      )
        v-icon mdi-delete
    v-card-text.pa-1
      v-form(ref="user")
        v-form-base#userForm(
          :value="editedItem",
          :schema="schema",
          @input:userForm="onFormInput"
        )
          v-select(
            slot="slot-item-key-roles",
            v-model="editedItem.roles",
            :items="['GA', 'RM', 'SS', 'SW', 'SH', 'CC']",
            attach,
            chips,
            dense,
            label="Allowed Roles",
            multiple,
            @change="sortRoles()"
          )
    v-divider
    v-card-actions
      v-btn(
        color="primary",
        v-if="editedItem.id && editedItem.status === STATUSES.ACTIVE",
        :disabled="isDirty",
        text,
        v-on:click.stop="deActivate(dialogKey)"
      ) De-Activate
      v-btn(
        color="primary",
        v-if="editedItem.id && editedItem.status === STATUSES.INACTIVE",
        :disabled="isDirty",
        text,
        v-on:click.stop="editedItem.status = STATUSES.ACTIVE; save(dialogKey)"
      ) Activate
      v-spacer
      v-btn(color="primary", text, v-on:click.stop="cancel(dialogKey)") Cancel
      v-btn(
        color="primary",
        :disabled="!isDirty",
        text,
        v-on:click.stop="save(dialogKey)"
      ) Save
</template>

<script>
import { storeMixin } from "../../mixins/storeMixin.js";
import { dialogsMixin } from "../../mixins/dialogsMixin.js";

export default {
  name: "user-dialog",
  mixins: [storeMixin, dialogsMixin],
  beforeMount() {
    if (!this.editedItem.id) {
      Object.assign(this.editedItem, this.defaultItem);
    }
  },
  data() {
    return {
      collectionName: "users",
      dialogKey: "userDialog",
      defaultItem: {
        fullName: "",
        role: "",
        roles: [],
        mobileNumber: "",
        hourlyRate: 0,
        notes: "",
        status: 0,
      },
    };
  },
  computed: {
    schema() {
      return Object.assign(
        {
          _groupKey: { type: "text", hidden: true },
          emailVerified: { type: "text", hidden: true },
          imageUrl: { type: "text", hidden: true },
          uid: { type: "text", hidden: true },
          code: {
            type: "text",
            label: "Code",
            flex: 2,
            sort: 1,
            rules: [
              this.required("User Code is required"),
              this.minLen(2),
              this.maxLen(8),
            ],
            disabled: true,
          },
          fullName: {
            type: "text",
            label: "Full Name",
            flex: 9,
            sort: 2,
            offset: 1,
            rules: [
              this.required("Full Name is required"),
              this.minLen(3),
              this.maxLen(40),
            ],
          },
          role: { type: "select", hidden: true },
          roles: {
            type: "text",
            label: "Allowed Roles",
            sort: 3,
            flex: 12,
            hidden: false,
            rules: [this.minLen(1)],
          },
          email: {
            type: "text",
            label: "Email",
            flex: 6,
            sort: 4,
            rules: [
              this.required("Email is required"),
              this.minLen(10),
              this.maxLen(10),
            ],
            disabled: this.editedItem.emailVerified,
          },
          mobileNumber: {
            type: "text",
            label: "Mobile Number",
            flex: 5,
            offset: 1,
            sort: 5,
            rules: [
              this.required("Mobile Number is required"),
              this.minLen(10),
              this.maxLen(10),
            ],
          },
          hourlyRate: {
            type: "text",
            label: `Hourly Rate(${process.env.VUE_APP_CURRENCY}):`,
            flex: 4,
            offset: 2,
            sort: 6,
            rules: [
              this.required(
                `Hourly rate(${process.env.VUE_APP_CURRENCY}) is required`
              ),
              this.minLen(1),
              this.maxLen(6),
            ],
          },
          status: {
            type: "select",
            label: "Status",
            items: ["Draft", "Active"],
            flex: 3,
            sort: 7,
            rules: [this.required("Status is required")],
            hidden: true,
          },
          notes: {
            type: "textarea",
            label: "Notes",
            flex: 9,
            sort: 8,
            rules: [this.maxLen(200)],
          },
        },
        this.baseSchema
      );
    },
  },
  methods: {
    sortRoles() {
      this.editedItem.roles = this.editedItem.roles.sort((r1, r2) => {
        const allRoles = ["GA", "RM", "SS", "SW", "SH", "CC"];
        return allRoles.indexOf(r1) - allRoles.indexOf(r2);
      });
      this.editedItem.role = this.editedItem.roles.length
        ? this.editedItem.roles[0]
        : ""; //first top role
    },
  },
  watch: {
    editedItem: {
      handler: function () {
        this.isDirty = true;
      },
      deep: true,
    },
  },
};
</script>